import Info from '@mui/icons-material/Info';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import {
  deleteCollectionManagementById,
  getCollectionManagementsByCompanyId,
} from 'lib/api';
import { unDoCompleteCollectionManagement } from 'lib/api/collections';
import DocumentSearcher from 'lib/common/DocumentSearcher';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import ConfirmAndExecuteDialog from 'lib/designSystem/ConfrimAndExecuteDialog';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import { validatePermissions } from 'lib/functions/utils';
import { loggerDev, showAlert } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthState } from 'services/redux/authSlice';
import { showBusinessNetwork } from 'services/redux/businessNetworkSlice';

import DetailedCollectionManagement from '../../../Documents/components/DetailedManagement';
import NewManagement from '../../../Documents/components/NewManagement';
import NewMultipleManagement from '../../../Documents/components/NewMultipleManagement';
import DocumentSelector from './components/DocumentSelector/indext';
import EditManagement from './components/EditManagement';
import RescheduleManagement from './components/ReSchedule';

const CollectionsManagementsCreated = (props: any) => {
  const { completed } = props;
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [collectionsData, setCollectionsData] = useState<any[]>([]);

  const endDateDefault = new Date();
  endDateDefault.setUTCHours(23, 59, 59, 999);
  const [endDate, setEndDate] = useState<any>(dayjs(endDateDefault));
  const [stakeholderIdentifier, setStakeholderIdentifier] = useState('');
  const [businessIdentifier, setBusinessIdentifier] = useState('');
  const [documentType, setDocumentType] = useState('factoring');
  const PAGE_SIZE = 10;
  const [openEditManagement, setOpenEditManagement] = useState(false);
  const [openEditManagementId, setOpenEditManagementId] = useState(0);
  const [description, setDescription] = useState('');
  const [possiblePaymentDate, setPossiblePaymentDate] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: PAGE_SIZE,
    total: 0,
    totalPages: 0,
  });

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogTitle, setConfirmDialogTitle] = useState('');
  const [confirmDialogDescription, setConfirmDialogDescription] = useState('');
  const [detailsManagementOpen, setDetailsManagementOpen] = useState(false);
  const [collectionManagementId, setCollectionManagementId] = useState(0);
  const [confirmAction, setConfirmAction] = useState<() => Promise<void>>(
    () => Promise.resolve,
  );
  const [buttonColor, setButtonColor] = useState<
    'primary' | 'error' | 'warning'
  >('primary');

  const [canHaveSubordinates, setCanHaveSubordinates] = useState(false);
  const [executiveId, setExecutiveId] = useState('all');
  const [executiveOptions, setExecutiveOptions] = useState<any[]>([]);

  const [rescheduleManagementOpen, setRescheduleManagementOpen] =
    useState(false);

  const handleConfirmUnDoCompleteDialog = (id: number) => {
    setConfirmDialogTitle('Descompletar gestión ' + `#${id}`);
    setConfirmDialogDescription(
      '¿Estás seguro de que deseas descompletar la gestión?',
    );
    setConfirmAction(() => async () => await handleUnDoComplete(id)); // Corregido
    setButtonColor('warning');
    setConfirmDialogOpen(true);
  };

  const handleConfirmDeleteDialog = (id: number) => {
    setConfirmDialogTitle('Eliminar gestión ' + `#${id}`);
    setConfirmDialogDescription(
      '¿Estás seguro de que deseas eliminar la gestión?',
    );
    setConfirmAction(() => async () => await handleDelete(id)); // Corregido
    setButtonColor('error');
    setConfirmDialogOpen(true);
  };

  const handleComplete = async (id: number) => {
    const management = collectionsData.find(
      (management) => management.id === id,
    );
    setOpenEditManagement(true);
    setOpenEditManagementId(id);
    setDescription(management.description);
    if (management.possiblePaymentDate) {
      const possiblePaymentDate = new Date(management.possiblePaymentDate);
      setPossiblePaymentDate(dayjs(possiblePaymentDate).format('YYYY-MM-DD'));
    } else {
      setPossiblePaymentDate('');
    }
  };
  const handleReschedule = (id: number) => {
    setRescheduleManagementOpen(true);
    const dueDate = new Date(
      collectionsData.find((management) => management.id === id).dueDate,
    );
    setOpenEditManagementId(id);
    if (dueDate) {
      dueDate.setUTCHours(11, 59, 59, 999);
      setDueDate(dayjs(dueDate).format('YYYY-MM-DD'));
    } else {
      setDueDate('');
    }
  };

  const handleUnDoComplete = async (id: number) => {
    if (!id) return;

    setConfirmDialogOpen(false);
    setLoading(true);
    try {
      await unDoCompleteCollectionManagement(dispatch, id);
      showAlert(dispatch, 'success', 'Gestión descompletada');
      window.location.reload();
    } catch (error) {
      loggerDev(error);
      showAlert(dispatch, 'error', 'Error al descompletar la gestión');
    }
  };

  const handleDelete = async (id: number) => {
    if (!id) return;

    setLoading(true);
    try {
      await deleteCollectionManagementById(dispatch, id);
      showAlert(dispatch, 'success', 'Gestión eliminada');
      window.location.reload();
    } catch (error) {
      loggerDev(error);
      showAlert(dispatch, 'error', 'Error al eliminar la gestión');
    }
    setLoading(false);
  };

  const handleDetailsManagement = (id: number) => {
    setDetailsManagementOpen(true);
    setCollectionManagementId(id);
  };

  const actions = [
    {
      action: handleDetailsManagement,
      actionLabel: 'Ver detalles',
    },
    {
      action: handleConfirmDeleteDialog,
      actionLabel: 'Eliminar',
    },
    ...(!completed
      ? [
          {
            action: handleComplete,
            actionLabel: 'Completar',
          },
          {
            action: handleReschedule,
            actionLabel: 'Reprogramar',
          },
        ]
      : [
          {
            action: handleConfirmUnDoCompleteDialog,
            actionLabel: 'Descompletar',
          },
        ]),
  ];

  const generateQuery = ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    let query = '';
    if (documentType) query += `documentType=${documentType}&`;
    if (endDate) query += `endDate=${endDate}&`;
    if (stakeholderIdentifier)
      query += `stakeholderIdentifier=${stakeholderIdentifier}&`;
    if (completed) query += `completed=${completed}&`;
    if (executiveId && executiveId !== 'all')
      query += `executiveId=${executiveId}&`;
    if (page) query += `page=${page}&pageSize=${pageSize}`;
    return query;
  };

  const searchCollectionsManagements = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    setLoading(true);
    try {
      const query = generateQuery({ page, pageSize });
      const response = await getCollectionManagementsByCompanyId(
        dispatch,
        query,
      );
      setCollectionsData(response.data);
      setPagination(response.pagination);
      setExecutiveOptions(response.executiveOptions);
    } catch (error) {
      loggerDev(error);
    }
    setLoading(false);
  };
  const isAdmin = validatePermissions(user, 'collection_admin');

  const handleShowStakeholderDetails = (id: string) => {
    const row: any = collectionsData.find((x: any) => x.id === id);
    if (!row) return;
    dispatch(
      showBusinessNetwork({
        id: row.stakeholderIdentifier,
        name: row.stakeholderName,
      }),
    );
  };

  const handleShowBusinessDetails = (id: string) => {
    const row: any = collectionsData.find((x: any) => x.id === id);
    if (!row) return;
    dispatch(
      showBusinessNetwork({
        id: row.businessIdentifier,
        name: row.businessName,
      }),
    );
  };

  const headers: {
    key: string;
    label: string;
    type?: any;
    icon?: any;
    handleAction?: any;
  }[] = [
    { key: 'id', label: 'ID', type: 'numeric-id' },
    ...(canHaveSubordinates
      ? [{ key: 'userOwnerName', label: 'Ejecutivo' }]
      : []),
    { key: 'elementType', label: 'Tipo', type: 'collection-type' },
    { key: 'description', label: 'Descripción' },
    { key: 'folio', label: 'Documento' },
    {
      key: 'businessName',
      label: 'Cliente',
      handleAction: handleShowBusinessDetails,
      icon: <Info fontSize="small" />,
    },
    {
      key: 'stakeholderName',
      label: 'Deudor',
      handleAction: handleShowStakeholderDetails,
      icon: <Info fontSize="small" />,
    },
    { key: 'state', label: 'Estado gestión' },
    ...(completed
      ? [{ key: 'possiblePaymentDate', label: 'Futuro pago', type: 'date' }]
      : []),
    ...(isAdmin ? [{ key: 'userOwnerName', label: 'Usuario' }] : []),
    ...(completed
      ? [{ key: 'completedAt', label: 'Completado', type: 'date' }]
      : [{ key: 'dueDate', label: 'Fecha gestión', type: 'due-date' }]),
  ];

  const reloadPage = () => {
    window.location.reload();
  };

  const [openDocumentSelector, setOpenDocumentSelector] = useState(false);
  const [openCreateNewManagement, setOpenCreateNewManagement] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const [openCreateNewManagementMultiple, setOpenCreateNewManagementMultiple] =
    useState(false);
  const [documentsForMultiple, setDocumentsForMultiple] = useState<any[]>([]);

  const handleConfirmSelection = (document: any) => {
    setSelectedDocument(document);
    loggerDev(document);
    setOpenDocumentSelector(false);
    setOpenCreateNewManagement(true);
  };

  const handleConfirmSelectionMultiple = (documents: any) => {
    setDocumentsForMultiple(documents);
    setOpenDocumentSelector(false);
    setOpenCreateNewManagementMultiple(true);
  };

  useEffect(() => {
    void searchCollectionsManagements({
      page: 0,
      pageSize: PAGE_SIZE,
    });
  }, []);

  useEffect(() => {
    const boss = validatePermissions(user, 'have_subordinates');
    const admin = validatePermissions(user, 'edit_subordinates');
    setCanHaveSubordinates(boss || admin);
  }, [user]);

  const title = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="body1" fontWeight="bold">
        {completed ? 'Gestiones realizadas' : 'Próximas gestiones'}
      </Typography>
      {!completed && (
        <LightTooltip
          title={
            <Typography padding={1}>
              Puedes buscar todas las gestiones pendientes con el buscador.
            </Typography>
          }
        >
          <Info fontSize="small" style={{ marginLeft: 4 }} />
        </LightTooltip>
      )}
    </div>
  );

  return (
    <div>
      <HeaderWithActions
        title={title}
        variant={'body1'}
        fontWeight="bold"
        buttons={[
          {
            name: 'Filtro',
            action: () => {},
            color: 'primary',
            customButton: (
              <DocumentSearcher
                documentType={documentType}
                setDocumentType={setDocumentType}
                searchData={searchCollectionsManagements}
                setData={setCollectionsData}
                setLoading={setLoading}
                endDate={endDate}
                setEndDate={setEndDate}
                stakeholderIdentifier={stakeholderIdentifier}
                setStakeholderIdentifier={setStakeholderIdentifier}
                businessIdentifier={businessIdentifier}
                setBusinessIdentifier={setBusinessIdentifier}
                pagination={pagination}
                executiveId={canHaveSubordinates ? executiveId : ''}
                setExecutiveId={canHaveSubordinates ? setExecutiveId : ''}
                executiveOptions={
                  canHaveSubordinates ? executiveOptions : undefined
                }
              />
            ),
            hidden: loading,
          },
        ]}
      />
      {loading ? (
        <CenteredCircularProgress relative />
      ) : (
        <TableWithPagination
          dataHeaders={headers}
          exportToFile="xlsx"
          data={collectionsData}
          rowsPerPageDefault={PAGE_SIZE}
          actions={actions}
          showActions
          setData={setCollectionsData}
          searchData={searchCollectionsManagements}
          pagination={pagination}
          setPagination={setPagination}
          lastElement
        />
      )}
      <ConfirmAndExecuteDialog
        open={!!confirmDialogOpen}
        title={confirmDialogTitle}
        description={confirmDialogDescription}
        onConfirm={confirmAction}
        onCancel={() => setConfirmDialogOpen(false)}
        setOpen={setConfirmDialogOpen}
        buttonColor={buttonColor}
      />
      {detailsManagementOpen && (
        <DetailedCollectionManagement
          openModal={detailsManagementOpen}
          setOpenModal={setDetailsManagementOpen}
          collectionManagementId={collectionManagementId}
          handleComplete={handleComplete}
        />
      )}
      {openCreateNewManagement && (
        <NewManagement
          openModal={openCreateNewManagement}
          setOpenModal={setOpenCreateNewManagement}
          documentId={selectedDocument?.id}
          setUp={reloadPage}
        />
      )}
      {openCreateNewManagementMultiple && (
        <NewMultipleManagement
          openModal={openCreateNewManagementMultiple}
          setOpenModal={setOpenCreateNewManagementMultiple}
          setUp={reloadPage}
          documentsWithId={documentsForMultiple}
        />
      )}
      {openDocumentSelector && (
        <DocumentSelector
          open={openDocumentSelector}
          setOpen={setOpenDocumentSelector}
          handleConfirmSelection={handleConfirmSelection}
          handleConfirmSelectionMultiple={handleConfirmSelectionMultiple}
        />
      )}
      {openEditManagement && (
        <EditManagement
          openEditManagementId={openEditManagementId}
          open={openEditManagement}
          setOpen={setOpenEditManagement}
          setDescription={setDescription}
          description={description}
          possiblePaymentDate={possiblePaymentDate}
          setPossiblePaymentDate={setPossiblePaymentDate}
          setConfirmDialogTitle={setConfirmDialogTitle}
          setConfirmDialogDescription={setConfirmDialogDescription}
          setConfirmAction={setConfirmAction}
          setButtonColor={setButtonColor}
          setConfirmDialogOpen={setConfirmDialogOpen}
        />
      )}
      {rescheduleManagementOpen && (
        <RescheduleManagement
          open={rescheduleManagementOpen}
          setOpen={setRescheduleManagementOpen}
          openEditManagementId={openEditManagementId}
          dueDate={dueDate}
          setDueDate={setDueDate}
          setConfirmDialogTitle={setConfirmDialogTitle}
          setConfirmDialogDescription={setConfirmDialogDescription}
          setConfirmAction={setConfirmAction}
          setButtonColor={setButtonColor}
          setConfirmDialogOpen={setConfirmDialogOpen}
        />
      )}
    </div>
  );
};

export default CollectionsManagementsCreated;
